export default __webpack_public_path__ + "static/media/steps__slider-img-3.bf2dccbb.png";